<template>
    <div class="rec-info">
        <div class="rec-banner">
            <div class="rec-banner__title">
                <span class="rec-dot" :class="{'is-empty': !single.records.length}"></span>
                <template v-if="single.records.length">该会议共有 <b>{{ single.records.length }}</b> 个录像</template>
                <template v-else>该会议没有录像</template>
                <span class="rec-banner__hint">若录像或纪要文件不正确，点击重新查询。</span>
                <span class="rec-banner__hint" v-if="mobile">请用电脑查看完整功能。</span>
            </div>
            <div class="rec-banner__actions">
                <el-button size="small" icon="el-icon-refresh-right" @click="$emit('rebuild')">重新查询</el-button>
                <el-button size="small" icon="el-icon-message" @click="$emit('resend')">重发通知</el-button>
            </div>
        </div>

        <template v-if="tab_index == 4">
            <div class="rec-empty" v-if="!records.length">没有找到录像。如有录制，请等待 2 小时以后再来查看。</div>

            <div class="rec-card" v-for="row in records" :key="row.id">
                <!-- 左:播放器 + 录制信息 -->
                <div class="rec-main">
                    <div class="rec-player">
                        <video v-if="row.download_url" :src="row.download_url" controls preload="metadata">
                            your browser does not support the video tag
                        </video>
                        <div v-else class="rec-player__none"><i class="el-icon-video-camera"></i> 暂无可播放的视频</div>
                    </div>
                    <div class="rec-meta">
                        <div class="rec-meta__item">
                            <span class="rec-label">录制日期</span>
                            <span class="rec-value">{{ timeOf(row).date }}</span>
                        </div>
                        <div class="rec-meta__item rec-meta__item--grow">
                            <span class="rec-label">起止时间</span>
                            <span class="rec-value">{{ timeOf(row).start }}<template v-if="timeOf(row).end"> – {{ timeOf(row).end }}</template></span>
                        </div>
                        <div class="rec-meta__item" v-if="timeOf(row).duration">
                            <span class="rec-label">时长</span>
                            <span class="rec-value">{{ timeOf(row).duration }}</span>
                        </div>
                    </div>
                </div>

                <!-- 右:下载 + 分享 -->
                <div class="rec-side">
                    <div class="rec-section-title"><span>文件下载</span></div>

                    <a v-if="row.download_url" class="rec-video-file" :href="row.download_url" target="_blank">
                        <i class="el-icon-video-camera rec-video-file__icon"></i>
                        <span class="rec-video-file__text">
                            <span class="rec-video-file__name">视频文件</span>
                            <span class="rec-video-file__sub">MP4<template v-if="sizeText(row.size)"> · {{ sizeText(row.size) }}</template></span>
                        </span>
                        <i class="el-icon-download rec-video-file__dl"></i>
                    </a>

                    <div class="rec-files" v-if="docsOf(row).length">
                        <div class="rec-file" v-for="doc in docsOf(row)" :key="doc.key">
                            <span class="rec-file__icon"><i class="el-icon-document"></i></span>
                            <span class="rec-file__text">
                                <span class="rec-file__name">{{ doc.name }}</span>
                                <span class="rec-file__sub">{{ doc.desc }}</span>
                            </span>
                            <el-select size="small" class="rec-file__fmt" v-model="fmtOf(row, doc).value">
                                <el-option v-for="x in doc.files" :key="x.file_type"
                                           :label="String(x.file_type).toUpperCase()" :value="x.file_type"></el-option>
                            </el-select>
                            <el-button type="text" class="rec-file__dl" icon="el-icon-download"
                                       :title="'下载' + doc.name"
                                       @click="downloadDoc(row, doc)"></el-button>
                        </div>
                    </div>
                    <div class="rec-muted" v-if="!row.download_url && !docsOf(row).length">暂无可下载的文件</div>

                    <div class="rec-section-title"><span>分享</span></div>
                    <div class="rec-shares">
                        <!-- 腾讯会议原生录像分享链接 -->
                        <div class="rec-share" v-if="row.play_url">
                            <div class="rec-share__head">
                                <span class="rec-share__text">
                                    <span class="rec-share__name">录像分享链接</span>
                                    <span class="rec-share__sub" v-if="row.password && row.disable_password != 1">
                                        访问密码 <b class="rec-code">{{ row.password }}</b>
                                    </span>
                                    <span class="rec-share__sub" v-else>无需密码</span>
                                </span>
                                <span class="rec-share__actions">
                                    <el-button type="text" icon="el-icon-view" @click="handleJumpUrl(row.play_url)">观看</el-button>
                                    <el-button size="small" plain type="primary" icon="el-icon-document-copy"
                                               @click="$emit('clipboard', row.play_url + (row.password && row.disable_password != 1 ? ' 分享密码:' + row.password : ''))">
                                        复制链接
                                    </el-button>
                                </span>
                            </div>
                            <template v-if="single.platform_code == 1 && !mobile">
                                <el-button type="text" class="rec-share__toggle"
                                           :icon="settingsOpen(row) ? 'el-icon-arrow-up' : 'el-icon-setting'"
                                           @click="toggleSettings(row)">{{ settingsOpen(row) ? '收起分享设置' : '分享设置' }}
                                </el-button>
                                <div class="rec-share__settings" v-if="settingsOpen(row)">
                                    <div class="rec-field">
                                        <span class="rec-field__label">分享对象</span>
                                        <el-select size="small" v-model="row.share_mode" placeholder="请选择分享对象">
                                            <el-option label="请选择" value='0'></el-option>
                                            <el-option label="所有人" value='1'></el-option>
                                            <el-option label="校内SSO" value='2'></el-option>
                                            <el-option label="与会者" value='3'></el-option>
                                        </el-select>
                                    </div>
                                    <div class="rec-field">
                                        <span class="rec-field__label">观看密码</span>
                                        <el-input size="small" v-model="row.password" clearable
                                                  :disabled="row.disable_password == 1" placeholder="八位密码"></el-input>
                                    </div>
                                    <div class="rec-field rec-field--switches">
                                        <el-switch v-model="row.disable_password" :active-value="'1'" :inactive-value="'0'"
                                                   active-text="不使用密码"></el-switch>
                                        <el-switch v-model="row.allow_download" :active-value="'1'" :inactive-value="'0'"
                                                   active-text="允许下载"></el-switch>
                                        <el-button size="small" type="primary" class="rec-dark-btn"
                                                   @click="$emit('share', row)">保存设置</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <!-- AI 回放:站内直接看;分享链接用不可猜的 uuid,可设观看密码(空=无需密码) -->
                        <div class="rec-share rec-share--ai" v-if="canPlayback">
                            <div class="rec-share__head">
                                <span class="rec-share__text">
                                    <span class="rec-share__name">AI 回放 <span class="rec-badge">AI</span></span>
                                    <span class="rec-share__sub">含章节、摘要与逐字稿的智能回放页</span>
                                </span>
                                <span class="rec-share__actions">
                                    <el-button type="text" icon="el-icon-view" @click="handlePlayback(row)">观看</el-button>
                                    <el-button size="small" plain icon="el-icon-document-copy"
                                               :disabled="!shareOf(row).url"
                                               @click="copyShareUrl(row)">复制链接
                                    </el-button>
                                </span>
                            </div>
                            <div class="rec-field rec-field--inline">
                                <span class="rec-field__label">访问密码</span>
                                <el-input size="small" clearable v-model="shareOf(row).password" maxlength="32"
                                          placeholder="留空则无需密码(4~32 位字母或数字)"
                                          @keyup.enter.native="applySharePassword(row)"></el-input>
                                <el-button size="small" class="rec-dark-btn" :loading="shareOf(row).saving"
                                           @click="applySharePassword(row)">应用
                                </el-button>
                            </div>
                        </div>
                        <div class="rec-muted" v-if="!row.play_url && !canPlayback">暂无可分享的链接</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
    name: 'meeting-view-recording-info',
    data() {
        return {
            record_tab: '1',
            // record_id -> {url, password, saving};按需从后端取,首次取时后端生成 uuid
            shares: {},
            // `${record_id}-${kind}` -> {value: 下载格式};各文档默认 docx
            formats: {},
            // record_id -> 是否展开腾讯录像分享设置
            settings: {},
        }
    },
    computed: {
        ...mapState(['user']),
        // 最新的录像排在前面(meeting_time 以 Y-m-d H:i:s 开头,字符串比较即可)
        records() {
            const list = Array.isArray(this.single.records) ? this.single.records.slice() : [];
            return list.sort((a, b) => String(b.meeting_time || '').localeCompare(String(a.meeting_time || '')));
        },
        // 前端粗判显隐(字段缺失即 false);后端 postData 严格校验
        canPlayback() {
            if (!this.user) return false;
            if (!this.single || this.single.platform_code != 1) return false; // 仅腾讯会议录像
            if (this.user.role_level == 4) return true;
            return this.single.host_id == this.user.user_id;
        }
    },
    props: {
        mobile: {},
        single: {},
        tab_index: {}
    },
    watch: {
        'single.records': {
            immediate: true,
            handler(records) {
                if (!this.canPlayback || !Array.isArray(records)) return;
                records.forEach(r => this.loadShare(r));
            }
        }
    },
    methods: {
        // meeting_time 形如 "2026-09-24 21:21:13-22:14:09"(腾讯),其他平台可能只有开始时间
        timeOf(row) {
            const t = String(row.meeting_time || '');
            const m = t.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})(?:-(\d{2}:\d{2}:\d{2}))?/);
            if (!m) return {date: t, start: '', end: '', duration: ''};
            let duration = '';
            if (m[3]) {
                const sec = s => s.split(':').reduce((acc, v) => acc * 60 + Number(v), 0);
                let d = sec(m[3]) - sec(m[2]);
                if (d < 0) d += 86400; // 跨零点
                const h = Math.floor(d / 3600), mi = Math.floor(d % 3600 / 60), se = d % 60;
                const pad = n => String(n).padStart(2, '0');
                duration = h ? `${h}:${pad(mi)}:${pad(se)}` : `${mi}:${pad(se)}`;
            }
            return {date: m[1], start: m[2], end: m[3] || '', duration};
        },
        sizeText(size) {
            const n = Number(size);
            if (!n || n <= 0) return '';
            if (n >= 1024 ** 3) return (n / 1024 ** 3).toFixed(2) + ' GB';
            if (n >= 1024 ** 2) return Math.round(n / 1024 ** 2) + ' MB';
            return Math.max(1, Math.round(n / 1024)) + ' KB';
        },
        docsOf(row) {
            return [
                {key: 'summary', name: '会议纪要', desc: '自动生成', files: row.meeting_summary},
                {key: 'transcripts', name: 'AI 转写', desc: '逐字稿', files: row.ai_transcripts},
                {key: 'minutes', name: 'AI 笔记', desc: '要点与待办', files: row.ai_minutes},
            ].filter(d => Array.isArray(d.files) && d.files.length);
        },
        fmtOf(row, doc) {
            const k = row.id + '-' + doc.key;
            if (!this.formats[k]) {
                const hit = doc.files.find(x => x.file_type === 'docx') || doc.files[0];
                this.$set(this.formats, k, {value: hit.file_type});
            }
            return this.formats[k];
        },
        downloadDoc(row, doc) {
            const fmt = this.fmtOf(row, doc).value;
            const hit = doc.files.find(x => x.file_type === fmt);
            if (hit && hit.download_address) window.open(hit.download_address, '_blank');
        },
        settingsOpen(row) {
            return !!this.settings[row.id];
        },
        toggleSettings(row) {
            this.$set(this.settings, row.id, !this.settings[row.id]);
        },
        handleJumpUrl(url) {
            window.open(url, "_blank");
        },
        // 直接打开分享链接 /rp/<uuid>,与复制出去的链接看到的是同一个页面(设了密码也要输)
        handlePlayback(row) {
            const s = this.shareOf(row);
            if (s.url) { window.open(s.url, '_blank'); return; }
            // 链接尚未取到:先同步开空白窗口,异步回调里再跳转——在回调里直接 window.open 会被浏览器当弹窗拦截
            const win = window.open('', '_blank');
            this.$api('Playback.ShareGet', {record_id: row.id}, false).then(res => {
                if (!res.data.success) { if (win) win.close(); this.$message.error(res.data.text || '获取回放链接失败'); return; }
                s.url = res.data.data.url;
                s.password = res.data.data.password || '';
                if (win) win.location.href = s.url; else window.open(s.url, '_blank');
            }).catch(() => { if (win) win.close(); });
        },
        shareOf(row) {
            if (!this.shares[row.id]) this.$set(this.shares, row.id, {url: '', password: '', saving: false});
            return this.shares[row.id];
        },
        loadShare(row) {
            const s = this.shareOf(row);
            if (s.url) return;
            this.$api('Playback.ShareGet', {record_id: row.id}, false).then(res => {
                if (res.data.success) {
                    s.url = res.data.data.url;
                    s.password = res.data.data.password || '';
                }
            });
        },
        applySharePassword(row) {
            const s = this.shareOf(row);
            const pwd = (s.password || '').trim();
            if (pwd !== '' && !/^[A-Za-z0-9]{4,32}$/.test(pwd)) {
                this.$message.error('AI 回放密码须为 4~32 位字母或数字;留空表示无需密码');
                return;
            }
            s.saving = true;
            this.$api('Playback.ShareSet', {record_id: row.id, password: pwd}, false).then(res => {
                s.saving = false;
                if (!res.data.success) { this.$message.error(res.data.text || '设置失败'); return; }
                s.url = res.data.data.url;
                s.password = res.data.data.password || '';
                this.$message.success(pwd ? 'AI 回放密码已设置' : '已取消密码,链接无需密码即可观看');
            }).catch(() => { s.saving = false; });
        },
        // 只复制链接,不带密码(密码由分享者另行告知)
        copyShareUrl(row) {
            const s = this.shareOf(row);
            if (s.url) this.$emit('clipboard', s.url);
        }
    }
}
</script>
<style lang="scss">
// 录像卡片:左播放器 + 右「文件下载 / 分享」。按容器宽度自动换行(抽屉里窄、详情页宽),不依赖视口断点。
.rec-info {
    $blue: #409EFF;
    $text: #303133;
    $sub: #909399;
    $line: #ebeef5;
    $dark: #1f2329;
    color: $text;
    font-variant-numeric: tabular-nums;

    .rec-banner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 12px;
        padding: 12px 16px;
        margin-bottom: 20px;
        background: #f0f9eb;
        border-radius: 4px;

        &__title {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 4px 8px;
            font-size: 15px;

            b { color: #67C23A; margin: 0 2px; }
        }

        &__hint { color: $sub; font-size: 13px; margin-left: 8px; }
        &__actions { display: flex; gap: 8px; .el-button + .el-button { margin-left: 0; } }
    }

    .rec-dot {
        width: 8px; height: 8px; border-radius: 50%; background: #67C23A; display: inline-block;
        &.is-empty { background: #C0C4CC; }
    }

    .rec-empty, .rec-muted { color: $sub; font-size: 13px; }
    .rec-empty { padding: 32px 0; text-align: center; }

    .rec-card {
        display: flex;
        flex-wrap: wrap;
        gap: 24px 32px;
        & + .rec-card { margin-top: 28px; padding-top: 28px; border-top: 1px solid $line; }
    }

    .rec-main { flex: 1.4 1 440px; min-width: 0; }
    .rec-side { flex: 1 1 340px; min-width: 0; display: flex; flex-direction: column; gap: 12px; }

    .rec-player {
        background: #000;
        aspect-ratio: 16 / 9;
        video { width: 100%; height: 100%; display: block; }
        &__none { height: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; color: #909399; }
    }

    .rec-meta {
        display: flex;
        border: 1px solid $line;
        border-top: 0;
        &__item {
            display: flex; flex-direction: column; gap: 6px;
            padding: 12px 16px;
            & + & { border-left: 1px solid $line; }
            &--grow { flex: 1; }
        }
    }

    .rec-label { font-size: 12px; color: $sub; letter-spacing: .05em; }
    .rec-value { font-size: 15px; white-space: nowrap; }

    .rec-section-title {
        display: flex; align-items: center; gap: 12px;
        font-size: 16px; font-weight: 600; letter-spacing: .1em;
        &::after { content: ''; flex: 1; height: 1px; background: $line; }
        &:not(:first-child) { margin-top: 12px; }
    }

    .rec-video-file {
        display: flex; align-items: center; gap: 14px;
        padding: 16px 20px;
        background: $blue; color: #fff; border-radius: 4px;
        text-decoration: none;
        transition: background .15s;
        &:hover, &:focus-visible { background: #3a8ee6; color: #fff; }
        &__icon { font-size: 22px; }
        &__text { flex: 1; display: flex; flex-direction: column; gap: 2px; }
        &__name { font-size: 15px; font-weight: 600; }
        &__sub { font-size: 13px; opacity: .85; }
        &__dl { font-size: 18px; }
    }

    .rec-files, .rec-shares { border: 1px solid $line; border-radius: 4px; }

    .rec-file {
        display: flex; align-items: center; gap: 12px;
        padding: 12px 16px;
        & + & { border-top: 1px solid $line; }
        &__icon {
            width: 34px; height: 34px; flex: none;
            display: flex; align-items: center; justify-content: center;
            background: #ecf5ff; color: #a0cfff; border-radius: 4px; font-size: 16px;
        }
        &__text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
        &__name { font-size: 14px; }
        &__sub { font-size: 12px; color: $sub; }
        &__fmt { width: 92px; flex: none; }
        &__dl { font-size: 18px; padding: 4px; }
    }

    .rec-share {
        padding: 14px 16px;
        display: flex; flex-direction: column; gap: 10px;
        & + & { border-top: 1px solid $line; }
        &__head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px 12px; }
        &__text { flex: 1 1 180px; display: flex; flex-direction: column; gap: 4px; }
        &__name { font-size: 15px; display: flex; align-items: center; gap: 8px; }
        &__sub { font-size: 12px; color: $sub; }
        &__actions { display: flex; align-items: center; gap: 12px; .el-button + .el-button { margin-left: 0; } }
        &__toggle { align-self: flex-start; padding: 0; font-size: 12px; }
        // AI 回放块:淡绿底突出显示(与顶部录像提示条同色系)
        &--ai {
            background: #f0f9eb;
            border-top-color: #e1f3d8 !important;
            .rec-badge { color: #67C23A; border-color: #c2e7b0; background: #fff; }
            .el-input__inner { background: #fff; }
        }
        &__settings {
            display: flex; flex-direction: column; gap: 10px;
            padding: 12px; background: #fafafa; border-radius: 4px;
        }
    }

    .rec-code { color: #F56C6C; font-weight: 600; letter-spacing: .12em; margin-left: 4px; }

    .rec-badge {
        font-size: 11px; line-height: 16px; padding: 0 6px;
        color: $blue; border: 1px solid #b3d8ff; border-radius: 2px; letter-spacing: .08em;
    }

    .rec-field {
        display: flex; align-items: center; gap: 10px;
        &__label { flex: none; width: 60px; font-size: 13px; color: #606266; }
        .el-input, .el-select { flex: 1; min-width: 0; }
        &--switches { flex-wrap: wrap; gap: 12px 20px; .el-button { margin-left: auto; } }
    }

    .rec-dark-btn {
        background: $dark; border-color: $dark; color: #fff;
        &:hover, &:focus { background: #3a3f47; border-color: #3a3f47; color: #fff; }
    }
}
</style>
